import { forwardRef, useState } from 'react'
import PhoneInputWithCountry from 'react-phone-number-input/input'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import FormRow from 'components/FormRow'
import { PhoneInputProps } from './types'

// react-phone-number-input's caret manager reads/writes DOM selection on
// whatever node its `ref` resolves to. `TextField`'s own forwarded `ref`
// points at the outlined root `<div>`, not the native `<input>` — redirect it
// through `inputRef` so caret handling matches the EUI branch exactly.
const PhoneTextField = forwardRef<HTMLInputElement, TextFieldProps>( ( props, ref ) => (
	<TextField {...props} inputRef={ref} />
) )
PhoneTextField.displayName = 'PhoneTextField'

export default function PhoneInputMui( {
	label,
	value,
	onChange,
	onBlur,
	placeholder,
	isInvalid = false,
	error,
	helpText,
}: PhoneInputProps ) {
	const [ hasBlurred, setHasBlurred ] = useState( false )

	const handleBlur = () => {
		setHasBlurred( true )
		if ( onBlur ) {
			onBlur( value )
		}
	}

	// Only show validation errors after the user has blurred the field
	const shouldShowError = hasBlurred && isInvalid

	return (
		<FormRow
			label={label}
			isInvalid={shouldShowError}
			error={shouldShowError ? error : undefined}
			helpText={helpText}
			fullWidth
		>
			{/* `error`/`fullWidth` come from FormRow's injection (below), not here —
			    it clones this element with those props already computed. */}
			<PhoneInputWithCountry
				country="US"
				value={value || undefined}
				onChange={( val ) => onChange( val ?? '' )}
				onBlur={handleBlur}
				placeholder={placeholder}
				inputComponent={PhoneTextField}
			/>
		</FormRow>
	)
}
